import useAxios, { UseAxiosResult } from 'axios-hooks';

export default function useTcrExchanges(): UseAxiosResult<string[]> {
  return useAxios<string[]>({
    url: 'tcr-enums/exchanges',
    method: 'GET'
  });
}
